<template>
  <div class="m-aDetail-list">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" :labelWidth="110" ></Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #phone="{ row }">{{ row.phone }}</template>
      <template #time="{ row }">{{ row.time }}</template>
    </Table>
  </div>
</template>

<script>
import { api_getActivityList } from '@/api/market'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";

export default {
  name: "marketActivityListDetail",
  mixins: [tableList],
  components: {
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
        },
      ],
      form: {},
      tableThData: [
        { prop: "name", label: "中奖商品", minWidth: "180", },
        { prop: "mallName", label: "中奖会员", minWidth: "180", },
        { prop: "phone", label: "会员手机号", minWidth: "180", },
        { prop: "time", label: "中奖时间", minWidth: "180", },
      ],
    };
  },
  created() {},
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      try {
        const data = await api_getActivityList(params)
        console.log('data: ', data);
        this.tableTrData = data.list
        this.total = data.count
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    // 点击核销
    onDestroy(row) {

    }
  },
};
</script>

<style lang="scss" scoped>
.m-aDetail-list {
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }
}
</style>
